<template>
    <div class="bg-white p-6 sm:w-400px sm:mt-6 mx-auto shadow rounded">
        <div class="mb-5">
            Hi {{ user.first_name }},<br /><br />
            To finish the signing up process and before you can manage your Laravel applications localizations, we need to verify your account first. It's easy — just follow the email instruction that we sent to <b>{{ user.email }}</b>
        </div>
        <div class="flex justify-end">
            <app-button class="btn-white mr-2"
                @click="resend"
                :loading="resendLoading">Resend</app-button>
            <app-button class="btn-white"
                :disabled="resendLoading"
                @click="showChangeEmailModal = true">Change Email</app-button>
        </div>
        <app-modal v-if="showChangeEmailModal"
            @keyupEnter="updateEmail">
            <template slot="header"
                class="font-thin">Update Email</template>
            <template slot="body">
                <app-input placeholder="New Email"
                    focus
                    class="form-group"
                    v-model="form.email"
                    :error="form.errors.get('email')"
                    @updated="form.errors.clear('email')"></app-input>
                <app-input type="password"
                    placeholder="Account Password"
                    :help-text="'For security purposes, please enter your '+env.VUE_APP_NAME+' account password.'"
                    v-model="form.password"
                    :error="form.errors.get('password')"
                    @updated="form.errors.clear('password')"></app-input>
            </template>
            <div slot="footer">
                <app-button class="btn-transparent"
                    @click="closeChangeEmailModal"
                    :disabled="updatingEmail">Cancel</app-button>
                <app-button class="btn-blue"
                    @click="updateEmail"
                    :loading="updatingEmail">Update</app-button>
            </div>
        </app-modal>
    </div>
</template>
<script>
    import Form from '@/helpers/Form'
    import { mapGetters } from 'vuex'
    export default {
        data() {
            return {
                resendLoading: false,
                changeEmailLoading: false,
                showChangeEmailModal: false,
                updatingEmail: false,
                env: process.env,
                form: new Form({
                    email: null,
                    password: null
                })
            }
        },
        computed: {
            ...mapGetters({
                user: 'auth/user'
            })
        },
        methods: {
            resend() {
                this.resendLoading = true
                this.$store.dispatch('auth/resendEmailConfirmation')
                    .then(({ data }) => {
                        this.resendLoading = false
                        this.$store.commit('notification/show', {
                            type: 'success',
                            title: 'Email Sent!',
                            html: 'A new email confirmation was sent to <b>' + this.user.email + '</b>'
                        })
                    })
                    .catch(({ response }) => {
                        this.resendLoading = false
                    })
            },
            closeChangeEmailModal() {
                this.showChangeEmailModal = false
                this.form.reset()
            },
            updateEmail() {
                this.updatingEmail = true
                this.form.errors.clear()
                this.$store.dispatch('account/updateEmail', this.form.payload())
                    .then(() => {
                        this.updatingEmail = false
                        this.$store.commit('notification/show', {
                            type: 'success',
                            title: 'Email Sent!',
                            html: 'A new email confirmation was sent to <b>' + this.user.email + '</b>'
                        })
                        this.closeChangeEmailModal()
                    })
                    .catch(({ response }) => {
                        this.updatingEmail = false
                        this.form.errors.record(response.data)
                    })
            }
        }
    }
</script>